import type { LOCALE_CODE } from '@pkg/config/languages/localeCodes';
import { SINGLETON } from '@pkg/config/sanity/schemas';
import { singletonDocId } from '@pkg/sanity-utils/singletonDocId';
import type { BusinessSiteManifest } from '../apis/sanity/queries/siteManifest';
import { businessSiteManifest } from '../apis/sanity/queries/siteManifest';

/**
 * Thin counterpart to apps/web `useSiteManifestQuery`.
 * Loads chrome from `singleton-theme-{locale}-business` only.
 *
 * Same as www: reactive params, so useFetch refetches when the locale switches
 * (the layout stays mounted across locale changes).
 */
export function useSiteManifestQuery() {
  const { locale } = useI18n();
  const themeId = computed(() => singletonDocId(SINGLETON.THEME, locale.value as LOCALE_CODE, 'business'));

  return useFetch<BusinessSiteManifest>('/api/sanity-fetch', {
    method: 'POST',
    body: {
      query: businessSiteManifest,
      params: reactive({
        themeId,
        // Required by nav portable-text / dynamicText projections inside mainNavFields
        locale,
      }),
    },
    key: 'business-site-manifest',
  });
}
